import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';
const IconFilter = t0 => {
  const $ = _c(12);
  let otherProps;
  let t1;
  if ($[0] !== t0) {
    ({
      color: t1,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
  } else {
    otherProps = $[1];
    t1 = $[2];
  }
  const color = t1 === undefined ? colorGray : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M0.784505208,1.899 L14.7845052,1.899" />;
    t3 = <path d="M0.416666667,9.399 L14.4166667,9.399" />;
    t4 = <path d="M11.4166667,0 L11.4166667,4" />;
    t5 = <path d="M3.41666667,6.66666667 L3.41666667,11.6666667" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== color) {
    t6 = <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square"><g transform="translate(1.000000, 1.000000)" stroke={color} strokeWidth="1.5">{t2}{t3}{t4}{t5}</g></g>;
    $[7] = color;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== otherProps || $[10] !== t6) {
    t7 = <svg height="14" viewBox="0 0 17 14" {...otherProps}>{t6}</svg>;
    $[9] = otherProps;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
IconFilter.propTypes = {
  color: PropTypes.string
};
export default IconFilter;